// extracted by mini-css-extract-plugin
export default {"row-desc":"QFb90McsQ0AdmUG","row-title":"vrs2EM2ho6fmHHF","row":"MM29nlxblfZ94wx"};